import React from 'react'
import { User } from '../../providers/context'
import { URLAction, useURLParams } from '../../providers/URLParams'
import { NewYearModal } from '../modals/newYear'
import { OutOfOfficeModal } from '../modals/outOfOffice'
import { TeacherTypeModal } from '../modals/teacherType'
import { UpdateContactMethodsTeacherModal, UpdateContactMethodsFamilyModal } from '../modals/updateContactMethods'
import { ComposeState } from './compose/composeTypes'
import { HomeTutorial } from './homeTutorial'

export const HomeOnboarding: React.FC<{
  user: User
  deleteGroup: (gID: number) => Promise<boolean>
  setComposeState: React.Dispatch<React.SetStateAction<ComposeState | undefined>>
}> = ({ user, deleteGroup, setComposeState }) => {
  const URLParams = useURLParams()

  // hide all autolaunch onboarding if the user has requested to open compose through the URL
  // we still need to render the tutorial so it works if manually launched, but we wont autolaunch it
  const [initallyRequestsOpenCompose] = React.useState(() => URLParams.has(URLAction.OpenCompose))

  return (
    <>
      {!initallyRequestsOpenCompose && (
        <>
          {user.type === 'teacher' && user.outOfOffice && <OutOfOfficeModal message={user.outOfOffice} />}
          {user.type === 'teacher' && user.newYear && (
            <NewYearModal deleteGroup={deleteGroup} classes={user.newYear?.suggestDeletingClasses || []} />
          )}
          {/* We should maybe move these next 3 modals to appModals so they are shown on any page. */}
          {user.requestUpdatedContacts &&
            (user.type === 'teacher' ? (
              <UpdateContactMethodsTeacherModal user={user} />
            ) : (
              <UpdateContactMethodsFamilyModal user={user} />
            ))}
          {user.type === 'teacher' && user.requestTeacherType && <TeacherTypeModal />}
        </>
      )}
      <HomeTutorial
        user={user}
        launchImmediately={user.showTutorial && !initallyRequestsOpenCompose}
        setComposeState={setComposeState}
      />
    </>
  )
}

export const hasImportantHomeOnboarding = (user: User) => {
  if (!!user.requestUpdatedContacts || !!user.showTutorial) return true
  if (user.type === 'teacher') return !!user.newYear // [these are unimportant] || !!user.outOfOffice || !!user.requestTeacherType
  return false
}
